var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import snakeCase from "lodash-es/snakeCase.js";
import { SelectedState } from "./selected-state.js";
import { OfferRadioButtonType } from "../common/offer-radio-button.js";
import { html } from "lit";
import { when } from "lit/directives/when.js";
var apiHost = "https://api.verticalinsure.com";

function formatCurrency(cents, currency) {
  var formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency
  });
  return formatter.format(cents / 100);
}

var titleCase = function titleCase(s) {
  return s.toLowerCase().replace(/^[-_]*(.)/, function (_, c) {
    return c.toUpperCase();
  }).replace(/[-_]+(.)/g, function (_, c) {
    return " " + c.toUpperCase();
  });
};

function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(window.atob(base64).split("").map(function (c) {
    return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(""));
  return JSON.parse(jsonPayload);
}

var dataToObject = function dataToObject(dataset) {
  return Object.keys(dataset).reduce(function (object, key) {
    object[snakeCase(key)] = dataset[key];
    return object;
  }, {});
};

var standardDisplayTemplate = function standardDisplayTemplate(selectedState, acceptAction, declineAction, renderPaymentElement, landingPageAction, quote, productTemplate, errors) {
  return html(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  <div id=\"offer-display\">\n    <div id=\"offer-tag\">Recommended</div>\n    <offer-header></offer-header>\n    <section id=\"offer-content\">\n      <descriptor-list .declined=", "></descriptor-list>\n      <section id=\"actions\">\n        ", "\n        ", "\n      </section>\n    </section>\n    ", "\n    <legal-disclaimer></legal-disclaimer>\n  </div>\n"])), selectedState === SelectedState.DECLINED, when(landingPageAction, function () {
    return html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          <landing-page-action></landing-page-action>\n        "])));
  }, function () {
    return html(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          <div><strong>*Required:</strong> Select an option to continue</div>\n          <offer-radio-button type=", " @change=", " ?checked=", ">\n            ", "\n          </offer-radio-button>\n          <offer-radio-button type=", " @change=", " ?checked=", ">\n            ", "\n          </offer-radio-button>\n        "])), OfferRadioButtonType.ACCEPTED, acceptAction, selectedState === SelectedState.ACCEPTED, productTemplate.accept_action_text || "Accept Coverage for ".concat((quote == null ? void 0 : quote.total) || (quote == null ? void 0 : quote.premium_amount) ? formatCurrency((quote == null ? void 0 : quote.total) || (quote == null ? void 0 : quote.premium_amount), quote == null ? void 0 : quote.currency) : ""), OfferRadioButtonType.DECLINED, declineAction, selectedState === SelectedState.DECLINED, productTemplate.decline_action_text || "Decline Coverage");
  }), when(errors.length > 0 && errors.some(function (v) {
    return v in FRIENDLY_ERROR_MESSAGE;
  }), function () {
    return html(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n          <section id=\"errors\" class=\"error-message\">\n            ", "\n          </section>\n        "])), errors.map(function (e) {
      return html(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["<p>", "</p>"])), FRIENDLY_ERROR_MESSAGE[e]);
    }));
  }), renderPaymentElement());
};

var FRIENDLY_ERROR_MESSAGE = {
  selection_required: "A selection is required."
};
export { FRIENDLY_ERROR_MESSAGE, apiHost, dataToObject, formatCurrency, parseJwt, standardDisplayTemplate, titleCase };